// Feature flags configuration
export const FEATURE_FLAGS = {
  ENABLE_PAYWALL: process.env.REACT_APP_ENABLE_PAYWALL === 'true' || false,
  ENABLE_ACTUAL_HOSTING: process.env.REACT_APP_ACTUAL_HOSTING_ENABLED === 'true' || false,
} as const;

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (flag: keyof typeof FEATURE_FLAGS): boolean => {
  return FEATURE_FLAGS[flag];
};

// Helper function to get feature flag value
export const getFeatureFlag = (flag: keyof typeof FEATURE_FLAGS): boolean => {
  return FEATURE_FLAGS[flag];
}; 